__turbopack_context__.v({
  "className": "yfO9eG_className",
  "variable": "yfO9eG_variable",
});
